export enum ComparisonOperators {
	Greater = '>',
	Less = '<',
	GreaterEqual = '>=',
	LessEqual = '<=',
	Equal = '===',
	NotEqual = '!==',
	IsTruthy = 'IsTruthy',
	IsFalsy = 'IsFalsy',
	In = 'IN',
	NotIn = 'NOT IN',
	Regex = 'REGEX',
	DataType = 'DATA TYPE',
	Contains = 'ARRAY_CONTAINS',
	IsNull = 'IS NULL',
	IsNotNull = 'IS NOT NULL',
	IsMissing = `IS MISSING`,
	Like = 'LIKE',
	IsSame = 'IsSame',
}
